//#region Magic Bell

export class Cls_MBUser {
  user: {
    id?: string;
    external_id?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    custom_attributes?: {
      plan?: string;
      pricing_version?: string;
      preferred_pronoun?: string;
    };
    phone_numbers?: string[];
  } = {};
}

export class Cls_MagiBellCategory {
  name!: string;
  value!: string;
}

export class Cls_MBNotificationMain {
  project_id?: number;
  unseen_count?: number;
  unread_count?: number;
  total?: number;
  total_pages?: number;
  per_page?: number;
  current_page?: number;
  notifications: Cls_MBNotification[] = [];
  user?: {
    external_id?: string;
    email?: string;
  };
}

export class Cls_MBNotification {
  id?: string;
  recipient?: {
    id?: string;
    external_id?: string;
    email?: string;
    first_name?: string;
    last_name?: null;
    phone_numbers?: any[];
  };
  title?: string;
  content?: string;
  action_url?: string;
  category?: string;
  topic?: null;
  custom_attributes?: null;
  meta_data?: null;
  sent_at?: number;
  seen_at?: null;
  read_at?: null;
  archived_at?: null;
}

export class Cls_MB_CreateNotificationMain {
  notification?: Cls_MB_CreateNotification;
}

export class Cls_MB_CreateNotification {
  title?: string;
  content?: string;
  category?: string;
  topic?: string;
  action_url?: string;
  recipients?: Cls_MBRecipient[];
}

export class Cls_MBRecipient {
  email?: string;
  external_id?: string;
  first_name?: string;
  last_name?: string;
  custom_attributes?: { plan?: string; pricing_version?: string; preferred_pronoun?: string };
  phone_numbers?: string[];
  matches?: string;
}

export class Cls_MB_CreateBroadCast {
  broadcast?: Cls_Broadcast;
}

export class Cls_Broadcast {
  title?: string;
  content?: string;
  category?: string;
  topic?: string;
  action_url?: string;
  recipients?: Cls_Recipient[] = [];
}

export class Cls_Recipient {
  email?: string;
  external_id?: string;
  first_name?: string;
  last_name?: string;
  phone_numbers?: string[];
}

//#endregion
